import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTournamentState } from '../api';
import { fireConfetti } from './Confetti';
import { toast } from '../toast';

const SEEN_KEY = 'wcfantasy.tournament-start-seen';

export default function TournamentStartWatcher() {
  const { data } = useQuery({
    queryKey: ['tournament-state'],
    queryFn: getTournamentState,
    refetchInterval: 60_000,
  });
  useEffect(() => {
    if (!data?.tournamentStarted || !data.firstKickoffAt) return;
    try {
      const seen = localStorage.getItem(SEEN_KEY);
      if (seen === data.firstKickoffAt) return;
      localStorage.setItem(SEEN_KEY, data.firstKickoffAt);
      fireConfetti(80);
      toast.success('🏆 Pasaules Kauss 2026 sākas!');
    } catch { /* ignore */ }
  }, [data?.tournamentStarted, data?.firstKickoffAt]);
  return null;
}
